function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { TRANSFER_REQUESTS_RECEIVED_RECEIVED, TRANSFER_REQUESTS_RECEIVED_REQUESTED, TRANSFER_REQUEST_CONFIRMATION_SENT, TRANSFER_REQUEST_CONFIRMATION_SUCCESS, TRANSFER_REQUEST_CONFIRMATION_FAILED } from '../actions/transferRequestActions';
var initialState = {
  fetching: true,
  items: [],
  itemRequestStatuses: {}
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case TRANSFER_REQUESTS_RECEIVED_REQUESTED:
      return Object.assign({}, state, {
        fetching: true
      });
    case TRANSFER_REQUESTS_RECEIVED_RECEIVED:
      return Object.assign({}, state, {
        fetching: false,
        items: payload
      });
    case TRANSFER_REQUEST_CONFIRMATION_SENT:
      return Object.assign({}, state, {
        itemRequestStatuses: Object.assign({}, state.itemRequestStatuses, _defineProperty({}, payload, 'fetching'))
      });
    case TRANSFER_REQUEST_CONFIRMATION_SUCCESS:
      return Object.assign({}, state, {
        itemRequestStatuses: Object.assign({}, state.itemRequestStatuses, _defineProperty({}, payload.requestcode, 'success'))
      });
    case TRANSFER_REQUEST_CONFIRMATION_FAILED:
      return Object.assign({}, state, {
        itemRequestStatuses: Object.assign({}, state.itemRequestStatuses, _defineProperty({}, payload, 'failed'))
      });
    default:
      return state;
  }
}